import axios from 'axios';

// Since the whole app is deployed identically on Vercel, we force the path to always be relative
// This entirely prevents Cross-Origin requests and fixes Vercel CORS issues permanently.
const API_URL = '/api';

const api = axios.create({ baseURL: API_URL });

// Attach JWT to every request
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('mono_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Auto-logout on 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mono_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const auth = {
  register: (data) => api.post('/auth/register', data).then(r => r.data),
  login: (data) => api.post('/auth/login', data).then(r => r.data),
  me: () => api.get('/auth/me').then(r => r.data),
};

// Posts
export const posts = {
  list: (params) => api.get('/posts', { params }).then(r => r.data),
  create: (data) => api.post('/posts', data).then(r => r.data),
  update: (id, data) => api.put(`/posts/${id}`, data).then(r => r.data),
  delete: (id) => api.delete(`/posts/${id}`).then(r => r.data),
  publish: (id) => api.post(`/posts/${id}/publish`).then(r => r.data),
};

// Scheduler
export const scheduler = {
  calendar: (month) => api.get('/scheduler/calendar', { params: { month } }).then(r => r.data),
  queue: () => api.get('/scheduler/queue').then(r => r.data),
  bestTimes: () => api.get('/scheduler/best-times').then(r => r.data),
  addToCalendar: (data) => api.post('/scheduler/calendar', data).then(r => r.data),
};

// Analytics
export const analytics = {
  summary: () => api.get('/analytics/summary').then(r => r.data),
  posts: () => api.get('/analytics/posts').then(r => r.data),
  trend: (params) => api.get('/analytics/trend', { params }).then(r => r.data),
};

// AI
export const ai = {
  generatePost: (data) => api.post('/ai/generate-post', data).then(r => r.data),
  contentIdeas: (data) => api.post('/ai/content-ideas', data).then(r => r.data),
  improvePost: (data) => api.post('/ai/improve-post', data).then(r => r.data),
  insights: () => api.get('/ai/insights').then(r => r.data),
};

// Integrations
export const integrations = {
  list: () => api.get('/integrations').then(r => r.data),
  connect: (data) => api.post('/integrations/connect', data).then(r => r.data),
  disconnect: (platform) => api.delete(`/integrations/${platform}`).then(r => r.data),
  oauthUrl: (platform) => `${API_URL}/integrations/oauth/${platform}`,
};

export default api;
